<template>
  <main>
    <div class="container pb-8">
      <!-- TODO: breadcrump -->

      <base-loading v-if="is_loading_product" />

      <div
        class="text-center py-6"
        v-else-if="has_error_product"
      >
        مشکلی در بارگذاری محصول به وجود آمده است.
      </div>

      <!--      <div class="flex">-->
      <!--        <nuxt-link-->
      <!--          :to="{name: 'warehouse.home', params: {store_slug}}"-->
      <!--          class="text-sm text-gray-400 px-3"-->
      <!--        >-->
      <!--          <nuxt-icon name="angle-up" class="inline-block rotate-90"></nuxt-icon>-->

      <!--          برگشت به فروشگاه-->
      <!--        </nuxt-link>-->
      <!--      </div>-->

      <template v-else-if="data_product?.id">
        <div class="relative row justify-center z-10">
          <div class="col lg:w-8/12">
            <div class="l-container2">
              <div class="row">
                <div class="col sm:w-6/12">
                  <div class="relative">
                    <base-image
                      :src="ImagePlaceholder"
                      class="w-full aspect-video"
                      v-if="!data_product.files.length"
                    />

                    <slider-product-image
                      :files="data_product.files"
                      :product-title="data_product.title"
                      @click="ref_gallery?.show(data_product.files)"
                    />
                  </div>
                </div>

                <div class="col sm:w-6/12 mt-4 phone:mt-0">
                  <div class="flex items-start justify-between">
                    <h1 class="text-base font-bold">
                      {{ data_product.title }}
                    </h1>

                    <base-dropdown class="mr-2">
                      <base-button
                        text
                        circle
                      >
                        <base-icon name="dots" />
                      </base-button>

                      <template #menu>
                        <base-dropdown-item @click="share">
                          <base-icon
                            name="share"
                            class="ml-1"
                          />
                          اشتراک گذاری
                        </base-dropdown-item>

                        <base-dropdown-item @click="refModalReport?.show(data_product.id)">
                          <base-icon
                            name="report"
                            class="ml-1"
                          />
                          گزارش محتوای نامناسب
                        </base-dropdown-item>
                      </template>
                    </base-dropdown>
                  </div>

                  <view-phone>
                    <div class="mt-4">
                      <template v-if="selected_variation">
                        <div>
                          <div class="flex text-sm mt-2">
                            <div class="ml-1">قیمت تکی:</div>

                            <base-currency
                              :currency="selected_variation.$price"
                              class="font-bold whitespace-nowrap"
                            />
                          </div>
                        </div>
                      </template>

                      <div
                        class="text-danger text-sm mt-4"
                        v-else
                      >
                        برای ادامه، گزینه های محصول را انتخاب کنید.
                      </div>
                    </div>

                    <div
                      class="mt-4"
                      v-if="has_variant_color"
                    >
                      <div class="text-sm">
                        رنگ‌بندی:
                        {{ selected_color?.value.title }}
                      </div>

                      <ul class="flex flex-wrap mt-2">
                        <li
                          class="ml-2 mb-2"
                          v-for="color in color_variants"
                          :key="color.value.id"
                          @click="select_color(color.value.id)"
                        >
                          <base-tooltip
                            :content="color.value.title"
                            placement="bottom"
                          >
                            <div
                              class="flex-center bg-white border border-solid border-gray-200 rounded-full p-1"
                              :class="{ 'border-primary': color.value.id === selected_color_id }"
                            >
                              <div
                                class="flex-center w-8 h-8 rounded-full border-2 border-solid border-white"
                                :style="{ background: color.value.value }"
                              >
                                <base-icon
                                  name="tick"
                                  v-if="color.value.id === selected_color_id"
                                  class="invert mix-blend-difference"
                                />
                              </div>
                            </div>
                          </base-tooltip>
                        </li>
                      </ul>
                    </div>
                  </view-phone>

                  <div
                    class="bg-gray-50 border border-solid border-gray-200 rounded-lg px-5 py-4 mt-4"
                  >
                    <h2 class="text-sm font-bold">
                      فروشنده:
                      {{ data_product.warehouse.title }}
                    </h2>

                    <div class="text-sm mt-2">
                      ارسال از:
                      {{ data_product.warehouse.city?.province?.title }}
                      {{ data_product.warehouse.city?.title }}
                    </div>
                  </div>

                  <ul class="text-sm space-y-2 mt-4">
                    <li
                      v-for="slogan in SLOGANS"
                      :key="slogan.title"
                    >
                      <base-icon
                        :name="slogan.icon"
                        class="text-primary text-lg ml-2"
                      />
                      {{ slogan.title }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="mt-6">
              <section class="l-container2">
                <h2 class="text-sm font-bold">ویژگی ها</h2>

                <ul class="divide-y divide-gray-200 mt-3">
                  <li class="flex items-center text-sm py-4">
                    <h3 class="text-gray-500 pl-4">تعداد در پک</h3>

                    <div class="text-left">
                      {{ data_product.quantity_in_package }}
                      عدد
                    </div>
                  </li>

                  <li
                    class="flex items-center text-sm py-4"
                    v-for="(meta, index) in data_product.metas"
                  >
                    <h3 class="text-gray-500 pl-4">
                      {{ meta.title }}
                    </h3>

                    <div class="text-left">
                      {{ meta.value }}
                    </div>
                  </li>
                </ul>
              </section>

              <section class="l-container2 mt-6">
                <h2 class="text-sm font-bold">توضیحات</h2>

                <p class="leading-loose text-gray-600 whitespace-break-spaces mt-2">
                  {{ data_product.description }}
                </p>
              </section>
            </div>
          </div>

          <div class="col lg:w-4/12 mt-6 phone:mt-0">
            <div class="sticky top-4">
              <view-desktop>
                <div
                  class="l-container2 mb-4"
                  v-if="has_variant_color"
                >
                  <div class="text-sm">
                    رنگ‌بندی:
                    {{ selected_color?.value.title }}
                  </div>

                  <ul class="flex flex-wrap mt-2">
                    <li
                      class="mb-2 ml-2"
                      v-for="color in color_variants"
                      :key="color.value.id"
                      @click="select_color(color.value.id)"
                    >
                      <base-tooltip
                        :content="color.value.title"
                        placement="bottom"
                      >
                        <div
                          class="flex-center bg-white border border-solid border-gray-200 rounded-full p-1"
                          :class="{ 'border-primary': color.value.id === selected_color_id }"
                        >
                          <div
                            class="flex-center w-8 h-8 rounded-full border-2 border-solid border-white"
                            :style="{ background: color.value.value }"
                          >
                            <base-icon
                              name="tick"
                              v-if="color.value.id === selected_color_id"
                              class="invert mix-blend-difference"
                            />
                          </div>
                        </div>
                      </base-tooltip>
                    </li>
                  </ul>
                </div>
              </view-desktop>

              <div class="l-container2">
                <template v-if="selected_variation">
                  <div>
                    <div class="flex text-sm">
                      <div class="ml-1">روش ارسال:</div>

                      <div class="font-bold">
                        ارسال با پست
                        <template v-if="data_product.warehouse.shipping?.type === 'pass_keraye'">
                          (پس کرایه)
                        </template>
                        <template v-else-if="data_product.warehouse.shipping?.type === 'free'">
                          (رایگان)
                        </template>
                      </div>
                    </div>

                    <view-desktop>
                      <div class="flex text-sm mt-2">
                        <div class="ml-1">قیمت تکی:</div>

                        <base-currency
                          :currency="selected_variation.$price"
                          class="font-bold whitespace-nowrap"
                        />
                      </div>
                    </view-desktop>

                    <hr class="hidden phone:block border-dashed my-4" />

                    <div
                      class="fixed lg:static bottom-0 left-0 w-full z-10 px-4 lg:px-0 py-3 lg:py-0 bg-white lg:bg-transparent shadow-lg lg:shadow-none z-10"
                    >
                      <div class="flex">
                        <add-to-cart-button
                          :id="selected_variation.id"
                          :stock="selected_variation.stock"
                          :quantity-in-package="data_product.quantity_in_package"
                          class="w-full"
                        >
                          <template #count-left="{ quantity }">
                            <base-currency
                              :currency="
                                quantity *
                                data_product.quantity_in_package *
                                selected_variation.$price
                              "
                              class="font-bold whitespace-nowrap"
                            />
                          </template>
                        </add-to-cart-button>

                        <view-phone
                          v-if="!cart.find(p => p.id === selected_variation.id)?.quantity"
                        >
                          <div class="text-center mr-4">
                            <div class="text-gray-400 text-xxs">قیمت تک</div>

                            <base-currency :currency="selected_variation.$price" />
                          </div>
                        </view-phone>
                      </div>

                      <base-button
                        :to="{ name: 'store.cart' }"
                        type="primary"
                        tag="router-link"
                        class="w-full mt-3"
                        v-if="cart.find(p => p.id === selected_variation.id)?.quantity"
                      >
                        رفتن به سبد خرید
                      </base-button>
                    </div>
                  </div>
                </template>

                <div
                  class="text-danger text-sm mt-4"
                  v-else
                >
                  برای ادامه، گزینه های محصول را انتخاب کنید.
                </div>
              </div>
            </div>
          </div>
        </div>

        <temp-related-products
          :product-id="data_product.id"
          product-base-link="store.product"
          :is-vitrin="true"
          class="relative z-0 mt-8"
        />
      </template>
    </div>

    <teleport to="body">
      <modal-gallery ref="ref_gallery" />

      <modal-report
        ref="refModalReport"
        @submit="report"
      />
    </teleport>
  </main>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { sprintf } from 'sprintf-js';
import { ROUTE_PUBLIC_PRODUCT_SHOW } from '~/assets/js/consts/publicRoutes.consts.js';
import ImagePlaceholder from 'assets/images/core/placeholder.png';
import useServerFetch from 'assets/js/composables/fetcher/useServerFetch.js';
import SliderProductImage from '~/components/sliders/SliderProductImage.vue';
import AddToCartButton from '~/components/other/AddToCartButton.vue';
import uniqBy from 'lodash/uniqBy';
import ModalGallery from '~/components/modals/ModalGallery.vue';
import BaseImage from '~/components/base/BaseImage.vue';
import BaseCurrency from '~/components/base/BaseCurrency.vue';
import BaseTooltip from '~/components/base/BaseTooltip.vue';
import BaseIcon from '~/components/base/BaseIcon.vue';
import BaseLoading from '~/components/base/BaseLoading.vue';
import BaseButton from '~/components/base/BaseButton.vue';
import useCart from '~/assets/js/composables/cart/useCart';
import ViewDesktop from '~/components/layouts/view-desktop.vue';
import ViewPhone from '~/components/layouts/view-phone.vue';
import ModalReport from '~/components/modals/ModalReport.vue';
import { storeReport } from '~/assets/js/api/report.api';
import BaseDropdown from '~/components/base/dropdown/BaseDropdown.vue';
import BaseDropdownItem from '~/components/base/dropdown/BaseDropdownItem.vue';
import TempRelatedProducts from '~/components/templates/TempRelatedProducts.vue';
import useShare from '~/assets/js/composables/fetcher/useShare';
import handleUseSeoMeta from '~/assets/js/helpers/handleUseSeoMeta';

definePageMeta({
  title: 'اطلاعات محصول',
  name: 'store.product',
  layout: 'layout-home',
});

const route = useRoute();
const router = useRouter();

const SLOGANS = [
  {
    icon: 'verify-bulk',
    title: 'ضمانت خرید توسط تامینیفای',
  },
  {
    icon: 'global-bulk',
    title: 'ارسال به تمام نقاط کشور',
  },
  {
    icon: 'call-bulk',
    title: 'پشتیبانی آنلاین',
  },
];
const selected_color_id = ref(null);
const ref_gallery = ref();
const refModalReport = ref();

const { cart } = useCart();

const {
  data: data_product,
  filters: filters_product,
  is_loading: is_loading_product,
  refresh: refresh_product,
  has_error: has_error_product,
  status: status_product,
  fetch: fetch_product,
  filter: filter_product,
} = await useServerFetch(sprintf(ROUTE_PUBLIC_PRODUCT_SHOW, route.params.product_id), {
  server: true,
  in_load: true,
  lazy: true,
  filters: {
    is_vitrin: {
      value: true,
    },
  },
  placeholder: {
    files: [],
    product_variations: [],
  },
  onResponse: rsData => {
    if (!rsData?.id) {
      throw createError({
        status: 404,
        statusMessage: 'محصول یافت نشد.',
        message: 'محصول یافت نشد.',
      });
    }
  },
});

const color_variants = computed(() => {
  return uniqBy(
    data_product.value?.product_variations
      ?.map(pv => pv.variation_types.filter(vt => vt.type.id === 1))
      .flat(),
    'value.id'
  );
});

const has_variant_color = computed(() => {
  return color_variants.value.length;
});

watch(has_variant_color, newVal => {
  if (has_variant_color.value) {
    select_color(color_variants.value[0].value.id);
  }
});

const selected_color = computed(() => {
  return color_variants.value.find(vt => vt.value.id === selected_color_id.value);
});

const selected_variation = computed(() => {
  if (data_product.value?.product_variations.length === 1) {
    return data_product.value.product_variations[0];
  }

  return data_product.value?.product_variations.find(
    pv =>
      pv.variation_types && pv.variation_types.find(vt => vt.value.id === selected_color_id.value)
  );
});

watch(
  () => cart.value.find(p => p.id === selected_variation.value?.id)?.quantity,
  newVal => {
    if (newVal) {
      document.body.classList.add('body--productInCart');
    } else {
      document.body.classList.remove('body--productInCart');
    }
  }
);

const select_color = color_id => {
  selected_color_id.value = color_id;
};

const report = passedData => {
  storeReport({
    '%id': passedData.id,
    'description': passedData.description,
  }).then(rs => {
    refModalReport.value.hide();
  });
};

const share = () => {
  useShare().shareLink(
    router.resolve({
      name: 'store.product',
      params: {
        product_id: data_product.value.id,
      },
      query: {
        utm_source: 'share',
        utm_medium: 'store-product',
        utm_campaign: 'product-share-' + data_product.value.id,
      },
    }).href,
    'اشتراک گذاری محصول',
    'محصول: ' + data_product.value.title
  );
};

useSeoMeta(
  handleUseSeoMeta({
    title: () => 'خرید عمده ' + data_product.value.title + ' به قیمت تولیدی',
    description: () =>
      'خرید عمده ' +
      data_product.value.title +
      ' با حاشیه سود بالا. فروش مستقیم و به قیمت تولیدی از تولیدکنندگان معتبر پوشاک در پلتفرم تامینیفای. برای مشاهده مدل‌ها کلیک کنید.',
    image: () => data_product.value.files[0]?.path,
  })
);

onMounted(async () => {
  document.body.classList.add('body--singleProduct');

  if (has_variant_color.value) {
    select_color(color_variants.value[0].value.id);
  }
});

onBeforeUnmount(() => {
  document.body.classList.remove('body--singleProduct', 'body--productInCart');
});
</script>

<style scoped></style>
